export const templateSignaturesFilial = (dataSession) => {
	const signatureConsejoAdminFilial = `<strong>Marcos M. Herrería Alamina</strong>
				<br>
				<strong>Consejero Secretario</strong> `;

	const signatureNOConsejoAdminFilial = `<strong>Mayra Chim Kantún</strong>
		<br>
		<strong>Secretaria</strong> `;

	return dataSession.nameOrgan === 'Consejo de Administración'
		? signatureConsejoAdminFilial
		: signatureNOConsejoAdminFilial;
};

export const templateSignatures = (dataSession) => {
	const signatureConsejoInconformidades = `<p><strong>Lic. Patricia González Sánchez</strong></p>
		<p><strong>Secretaria Técnica de la Comisión de Inconformidades</strong></p> `;

	const signatureNOConsejoInconformidades = `<b><strong>Marcos Manuel Herrería Alamina</strong></b>
		<br>
		<b><strong>Secretario General y Jurídico del Instituto del Fondo Nacional de la Vivienda para los Trabajadores.</strong></b> `;

	return dataSession.nameOrgan === 'Comisión de Inconformidades'
		? signatureConsejoInconformidades
		: signatureNOConsejoInconformidades;
};
